"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var function_1 = require("fp-ts/lib/function");
var Traversable_1 = require("fp-ts/lib/Traversable");
var Option_1 = require("fp-ts/lib/Option");
var Either_1 = require("fp-ts/lib/Either");
var rxjs_1 = require("rxjs");
var Array_1 = require("fp-ts/lib/Array");
var of_1 = require("rxjs/observable/of");
var setoid_utils_1 = require("./setoid.utils");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var array_utils_1 = require("./array.utils");
var NonEmptyArray_1 = require("fp-ts/lib/NonEmptyArray");
exports.URI = 'RemoteData';
var RemoteDataStatus;
(function (RemoteDataStatus) {
    RemoteDataStatus["Initial"] = "Initial";
    RemoteDataStatus["Pending"] = "Pending";
    RemoteDataStatus["Failure"] = "Failure";
    RemoteDataStatus["Success"] = "Success";
})(RemoteDataStatus = exports.RemoteDataStatus || (exports.RemoteDataStatus = {}));
//tslint:disable no-any no-use-before-declare
var RemoteInitial = /** @class */ (function () {
    function RemoteInitial() {
        this.status = RemoteDataStatus.Initial;
    }
    RemoteInitial.prototype.alt = function (fy) {
        return fy;
    };
    RemoteInitial.prototype.ap = function (fab) {
        return this;
    };
    RemoteInitial.prototype.chain = function (f) {
        return this;
    };
    RemoteInitial.prototype.extend = function (f) {
        return this;
    };
    RemoteInitial.prototype.fold = function (initial, pending, failure, success) {
        return initial();
    };
    RemoteInitial.prototype.getOrElse = function (f) {
        return f();
    };
    RemoteInitial.prototype.map = function (f) {
        return this;
    };
    /**
     * Maps over this RemoteData value, producing new Observable
     */
    RemoteInitial.prototype.map$ = function (f) {
        return of_1.of(this);
    };
    RemoteInitial.prototype.getOrElseValue = function (value) {
        return value;
    };
    RemoteInitial.prototype.reduce = function (f, b) {
        return b;
    };
    RemoteInitial.prototype.traverse = function (F) {
        var _this = this;
        return function (f) { return F.of(_this); };
    };
    RemoteInitial.prototype.isPending = function () {
        return false;
    };
    RemoteInitial.prototype.isFailure = function () {
        return false;
    };
    RemoteInitial.prototype.isSuccess = function () {
        return false;
    };
    RemoteInitial.prototype.isInitial = function () {
        return true;
    };
    RemoteInitial.prototype.toOption = function () {
        return Option_1.none;
    };
    RemoteInitial.prototype.toNullable = function () {
        return null;
    };
    RemoteInitial.prototype.exists = function (p) {
        return false;
    };
    RemoteInitial.prototype.contains = function (S, value) {
        return false;
    };
    RemoteInitial.prototype.do = function (thunk) { };
    RemoteInitial.prototype.filter = function (p) {
        return this;
    };
    return RemoteInitial;
}());
exports.RemoteInitial = RemoteInitial;
var RemoteFailure = /** @class */ (function () {
    function RemoteFailure(error) {
        this.error = error;
        this.status = RemoteDataStatus.Failure;
    }
    RemoteFailure.prototype.alt = function (fy) {
        return fy;
    };
    RemoteFailure.prototype.ap = function (fab) {
        return fab.status === RemoteDataStatus.Failure ? fab : this;
    };
    RemoteFailure.prototype.chain = function (f) {
        return this;
    };
    RemoteFailure.prototype.extend = function (f) {
        return this;
    };
    RemoteFailure.prototype.fold = function (initial, pending, failure, success) {
        return failure(this.error);
    };
    RemoteFailure.prototype.getOrElse = function (f) {
        return f();
    };
    RemoteFailure.prototype.map = function (f) {
        return this;
    };
    /**
     * Maps over this RemoteData value, producing new Observable
     */
    RemoteFailure.prototype.map$ = function (f) {
        return of_1.of(this);
    };
    RemoteFailure.prototype.getOrElseValue = function (value) {
        return value;
    };
    RemoteFailure.prototype.reduce = function (f, b) {
        return b;
    };
    RemoteFailure.prototype.traverse = function (F) {
        var _this = this;
        return function (f) { return F.of(_this); };
    };
    RemoteFailure.prototype.isInitial = function () {
        return false;
    };
    RemoteFailure.prototype.isPending = function () {
        return false;
    };
    RemoteFailure.prototype.isFailure = function () {
        return true;
    };
    RemoteFailure.prototype.isSuccess = function () {
        return false;
    };
    RemoteFailure.prototype.toOption = function () {
        return Option_1.none;
    };
    RemoteFailure.prototype.toNullable = function () {
        return null;
    };
    RemoteFailure.prototype.exists = function (p) {
        return false;
    };
    RemoteFailure.prototype.contains = function (S, value) {
        return false;
    };
    RemoteFailure.prototype.do = function (thunk) { };
    RemoteFailure.prototype.filter = function (p) {
        return this;
    };
    return RemoteFailure;
}());
exports.RemoteFailure = RemoteFailure;
var RemoteSuccess = /** @class */ (function () {
    function RemoteSuccess(value) {
        this.value = value;
        this.status = RemoteDataStatus.Success;
    }
    RemoteSuccess.prototype.alt = function (fy) {
        return this;
    };
    RemoteSuccess.prototype.ap = function (fab) {
        return fab.status === RemoteDataStatus.Success ? this.map(fab.value) : fab;
    };
    RemoteSuccess.prototype.chain = function (f) {
        return f(this.value);
    };
    RemoteSuccess.prototype.extend = function (f) {
        return RemoteDataUtils.success(f(this));
    };
    RemoteSuccess.prototype.fold = function (initial, pending, failure, success) {
        return success(this.value);
    };
    RemoteSuccess.prototype.getOrElse = function (f) {
        return this.value;
    };
    RemoteSuccess.prototype.map = function (f) {
        return RemoteDataUtils.success(f(this.value));
    };
    /**
     * Maps over this RemoteData value, producing new Observable
     */
    RemoteSuccess.prototype.map$ = function (f) {
        return f(this.value);
    };
    RemoteSuccess.prototype.getOrElseValue = function (value) {
        return this.value;
    };
    RemoteSuccess.prototype.reduce = function (f, b) {
        return f(b, this.value);
    };
    RemoteSuccess.prototype.traverse = function (F) {
        var _this = this;
        return function (f) { return F.map(f(_this.value), function (b) { return RemoteDataUtils.success(b); }); };
    };
    RemoteSuccess.prototype.isInitial = function () {
        return false;
    };
    RemoteSuccess.prototype.isPending = function () {
        return false;
    };
    RemoteSuccess.prototype.isFailure = function () {
        return false;
    };
    RemoteSuccess.prototype.isSuccess = function () {
        return true;
    };
    RemoteSuccess.prototype.toOption = function () {
        return Option_1.some(this.value);
    };
    RemoteSuccess.prototype.toNullable = function () {
        return this.value;
    };
    RemoteSuccess.prototype.exists = function (p) {
        return p(this.value);
    };
    RemoteSuccess.prototype.contains = function (S, value) {
        return S.equals(this.value, value);
    };
    RemoteSuccess.prototype.do = function (thunk) {
        thunk(this.value);
    };
    RemoteSuccess.prototype.filter = function (p) {
        return p(this.value) ? this : RemoteDataUtils.initial;
    };
    return RemoteSuccess;
}());
exports.RemoteSuccess = RemoteSuccess;
var RemotePending = /** @class */ (function () {
    function RemotePending() {
        this.status = RemoteDataStatus.Pending;
    }
    RemotePending.prototype.alt = function (fy) {
        return fy;
    };
    RemotePending.prototype.ap = function (fab) {
        return this;
    };
    RemotePending.prototype.chain = function (f) {
        return this;
    };
    RemotePending.prototype.extend = function (f) {
        return this;
    };
    RemotePending.prototype.fold = function (initial, pending, failure, success) {
        return pending();
    };
    RemotePending.prototype.getOrElse = function (f) {
        return f();
    };
    RemotePending.prototype.map = function (f) {
        return this;
    };
    /**
     * Maps over this RemoteData value, producing new Observable
     */
    RemotePending.prototype.map$ = function (f) {
        return of_1.of(this);
    };
    RemotePending.prototype.getOrElseValue = function (value) {
        return value;
    };
    RemotePending.prototype.reduce = function (f, b) {
        return b;
    };
    RemotePending.prototype.traverse = function (F) {
        var _this = this;
        return function (f) { return F.of(_this); };
    };
    RemotePending.prototype.isInitial = function () {
        return false;
    };
    RemotePending.prototype.isPending = function () {
        return true;
    };
    RemotePending.prototype.isFailure = function () {
        return false;
    };
    RemotePending.prototype.isSuccess = function () {
        return false;
    };
    RemotePending.prototype.toOption = function () {
        return Option_1.none;
    };
    RemotePending.prototype.toNullable = function () {
        return null;
    };
    RemotePending.prototype.exists = function (p) {
        return false;
    };
    RemotePending.prototype.contains = function (S, value) {
        return false;
    };
    RemotePending.prototype.do = function (thunk) { };
    RemotePending.prototype.filter = function (p) {
        return this;
    };
    return RemotePending;
}());
exports.RemotePending = RemotePending;
var RemoteDataUtils;
(function (RemoteDataUtils) {
    //constructors
    var setoidStrict = setoid_utils_1.SetoidUtils.setoidStrict;
    // export const
    RemoteDataUtils.failure = function (error) { return new RemoteFailure(error); };
    RemoteDataUtils.success = function (value) { return new RemoteSuccess(value); };
    RemoteDataUtils.pending = new RemotePending();
    RemoteDataUtils.initial = new RemoteInitial();
    //filters
    RemoteDataUtils.isFailure = function (data) { return data.isFailure(); };
    RemoteDataUtils.isSuccess = function (data) { return data.isSuccess(); };
    RemoteDataUtils.isPending = function (data) { return data.isPending(); };
    RemoteDataUtils.isInitial = function (data) { return data.isInitial(); };
    //Setoid
    RemoteDataUtils.getSetoid = function (S) {
        return {
            equals: function (x, y) {
                return x.fold(function () { return y.isInitial(); }, function () { return y.isPending(); }, function (xError) { return y.fold(function_1.constFalse, function_1.constFalse, function (yError) { return yError === xError; }, function_1.constFalse); }, function (ax) { return y.fold(function_1.constFalse, function_1.constFalse, function_1.constFalse, function (ay) { return S.equals(ax, ay); }); });
            },
        };
    };
    RemoteDataUtils.strictRDSetoid = RemoteDataUtils.getSetoid(setoidStrict);
    RemoteDataUtils.strictRDOptionSetoid = RemoteDataUtils.getSetoid(Option_1.getSetoid(setoidStrict));
    //Monad
    RemoteDataUtils.of = RemoteDataUtils.success;
    RemoteDataUtils.ap = function (fab, fa) {
        return fa.ap(fab);
    };
    RemoteDataUtils.map = function (fa, f) { return fa.map(f); };
    RemoteDataUtils.chain = function (fa, f) {
        return fa.chain(f);
    };
    //Foldable
    RemoteDataUtils.reduce = function (fa, b, f) { return fa.reduce(f, b); };
    //Alt
    RemoteDataUtils.alt = function (fa, fb) { return fa.alt(fb); };
    //Extend
    RemoteDataUtils.extend = function (fla, f) {
        return fla.extend(f);
    };
    function fromOption(option, error) {
        if (Option_1.isNone(option)) {
            return RemoteDataUtils.failure(error());
        }
        else {
            return RemoteDataUtils.success(option.value);
        }
    }
    RemoteDataUtils.fromOption = fromOption;
    function fromEither(either) {
        if (Either_1.isLeft(either)) {
            return RemoteDataUtils.failure(either.value);
        }
        else {
            return RemoteDataUtils.success(either.value);
        }
    }
    RemoteDataUtils.fromEither = fromEither;
    function toPromise(data) {
        return new Promise(function (resolve, reject) {
            switch (data.status) {
                case RemoteDataStatus.Success: {
                    return resolve(data.value);
                }
                case RemoteDataStatus.Failure: {
                    return reject(data.error);
                }
            }
        });
    }
    RemoteDataUtils.toPromise = toPromise;
    //rx extension
    /**
     * Maps over Observable's inner RemoteData value
     * When Observable emits a `success(value)`, transforms the `value` using the function `f`. Example:
     * ```ts
     * const doubleAmount$ = amount$.mapRD(amount => amount * 2);
     * // amount$ emits:       initial-pending-success(5)
     * // doubleAmount$ emits: initial-pending-success(10)
     * // or
     * // amount$ emits:       initial-pending-failure
     * // doubleAmount$ emits: initial-pending-failure
     * ```
     */
    function mapRD(f) {
        return this.map(function (data) { return data.map(function (value) { return f(value); }); });
    }
    RemoteDataUtils.mapRD = mapRD;
    rxjs_1.Observable.prototype['mapRD'] = mapRD;
    /**
     * Maps over Observable's inner RemoteData<Option> value
     * When Observable emits a `success(some(value))` (it's like mapRD but value is Option), transforms the value using the function `f`. Example:
     * ```ts
     * const name$: Observable<RemoteData<Option<string>>> = ...;
     * const advisorTitle = name$.mapRDOption(name => `Advisor name is ${name}`);
     *  // name$ emits:         initial-pending-success(some('Mikhail'))
     *  // advisorTitle$ emits: initial-pending-success(some('Advisor name is Mikhail'))
     *  // or
     *  // name$ emits:         initial-pending-success(none)
     *  // advisorTitle$ emits: initial-pending-success(none)
     *  // or
     *  // name$ emits:        initial-pending-failure
     *  // advisorTitle emits: initial-pending-failure
     * ```
     */
    function mapRDOption(f) {
        return this.mapRD(function (opt) { return opt.map(f); });
    }
    RemoteDataUtils.mapRDOption = mapRDOption;
    rxjs_1.Observable.prototype['mapRDOption'] = mapRDOption;
    /**
     * Chains over Observable's inner RemoteData value
     * When Observable emits a `success(value)`, transform `value` into another remote data using the function `f`.
     * For example lets imagine we have remote data with some array,
     * and we want to transform remote data to failure state when array with zero length:
     * ``` ts
     * type Task = { id: number; name: string };
     * const tasks$: Observable<RemoteData<Task[]>> = ...;
     * const nonEmptyTaskArray$ = tasks$.chainRD(tasks => {
     *    if(tasks.length === 0) {
     *        return failure(new Error('zero length!'))
     *    }
     *    return success(tasks);
     * });
     * //When length === 0:
     * //tasks$ emits:             initial-pending-success([])
     * //nonEmptyTaskArray$ emits: initial-pending-failure(Error: zero length!)
     * //When length > 0:
     * //tasks$ emits:             initial-pending-success([{id: 1, name: 'task1'}])
     * //nonEmptyTaskArray$ emits: initial-pending-success([{id: 1, name: 'task1'}])
     * ```
     *
     */
    function chainRD(f) {
        return this.map(function (data) { return data.chain(function (value) { return f(value); }); });
    }
    RemoteDataUtils.chainRD = chainRD;
    rxjs_1.Observable.prototype['chainRD'] = chainRD;
    /**
     * Chains over Observable's inner RemoteData<Option> value
     * When Observable emits a `success(some(value))`, transform `value` into another remote data using the function `f`.
     * For example lets imagine we have remote data with some array,
     * and we want transform remote data to failure state when array with zero length:
     * ``` ts
     * type Task = { id: number; name: string };
     * const tasks$: Observable<RemoteData<Option<Task[]>>> = of(success(some([])));
     * const nonEmptyTaskArray$ = tasks$.chainRDOption(tasks => {
     *    if (tasks.length === 0) {
     *        return failure(some(new Error('zero length!')));
     *    }
     *    return success(some(tasks));
     * });
     * //When length === 0:
     * //tasks$ emits:       initial-pending-success(some([]))
     * //nonEmptyTaskArray$: initial-pending-failure(some(Error: zero length!))
     * //When length > 0:
     * //tasks$ emits:             initial-pending-success(some([{id: 1, name: 'task1'}]))
     * //nonEmptyTaskArray$ emits: initial-pending-success(some([{id: 1, name: 'task1'}]))
     * ```
     *
     */
    function chainRDOption(f) {
        return this.chainRD(function (opt) { return opt.foldL(function () { return RemoteDataUtils.success(Option_1.none); }, function (value) { return f(value); }); });
    }
    RemoteDataUtils.chainRDOption = chainRDOption;
    rxjs_1.Observable.prototype['chainRDOption'] = chainRDOption;
    /**
     * SwithcMaps over Observable's inner RemoteData value
     * This method is like switchMap from rxjs, but callback triggers only when it's success remote data inside stream. Example:
     * ```ts
     * const apiMethod: Function1<string, Observable<RemoteData<Array<any>>>> = ...;
     * const id$: Observable<RemoteData<string>> = ...;
     * const data$: Observable<RemoteData<Array<any>>> = id$.switchMapRD(id => apiMethod(id));
     * //id$ emits:   initial-pending-success(string)
     * //data$ emits: initial-pending-success(any[])
     * ```
     */
    function switchMapRD(f) {
        return this.switchMap(function (data) { return data.map$(function (value) { return f(value); }); });
    }
    RemoteDataUtils.switchMapRD = switchMapRD;
    rxjs_1.Observable.prototype['switchMapRD'] = switchMapRD;
    /**
     * This method is like switchMap from rxjs, but callback triggers only when value in stream is success(some(a)). Example:
     * ```ts
     * const apiMethod: Function1<string, Observable<RemoteData<Option<Array<any>>>>> = ...;
     * const id$: Observable<RemoteData<Option<string>>> = ...;
     * const data$ = id$.switchMapRDOption(id => apiMethod(id));
     * //id$ emits:   initial-pending-success(none)-success(some(string))
     * //data$ emits: initial-pending-success(none)-success(some(any[]))
     * ```
     */
    function switchMapRDOption(f) {
        return this.switchMapRD(function (opt) {
            return opt.foldL(function () { return rxjs_1.Observable.of(RemoteDataUtils.success(Option_1.none)); }, function (value) { return f(value).mapRD(Option_1.some); });
        });
    }
    RemoteDataUtils.switchMapRDOption = switchMapRDOption;
    rxjs_1.Observable.prototype['switchMapRDOption'] = switchMapRDOption;
    /**
     * Applies thunk to inner RemoteData value.
     * It accepts callback which would be called with a value been passed in case of success(a) in the stream.
     * Like mapRD, but doesn't modify the value inside stream, just calls callback as a side effect.
     * Use with caution and only for producing side effects. Example:
     * ``` ts
     * const text$: Observable<RemoteData<string>> = ...;
     * const subj$ = new Subject<number>();
     * text$.doRD(str => {
     * 	  subj$.next(parseInt(str));
     * }).subscribe();
     * //text$ emits: initial-pending-failure-success(number)
     * //subj$ emits: ------------------------number--------
     * ```
     */
    function doRD(f) {
        return this.do(function (data) {
            if (data.isSuccess()) {
                f(data.value);
            }
        });
    }
    RemoteDataUtils.doRD = doRD;
    rxjs_1.Observable.prototype['doRD'] = doRD;
    /**
     * Applies thunk to inner RemoteData value.
     * This method like doRD, but callback will trigger when value in stream will be success(some(value)). Example:
     * ``` ts
     * const text$: Observable<RemoteData<Option<string>>> = ...;
     * const subj$ = new Subject<number>();
     * text$
     * .doRDOption(str => {
     * subj$.next(parseInt(str.value));
     * })
     * .subscribe();
     * //text$ emits: initial-pending-failure-success(none)-success(some(string))
     * //subj$ emits: --------------------------------------number---------------
     * ```
     */
    function doRDOption(f) {
        return this.do(function (data) {
            if (data.isSuccess() && data.value.isSome()) {
                f(data.value.value);
            }
        });
    }
    RemoteDataUtils.doRDOption = doRDOption;
    rxjs_1.Observable.prototype['doRDOption'] = doRDOption;
    /**
     * Unwraps inner RemoteData filtering only RemoteSuccess values.
     * Use with caution, resulting observable may not emit any values. Example:
     * ``` ts
     * const text$: Observable<RemoteData<string>> = ...;
     * const successText$ : Observable<RemoteData<string>> = text$.filterSuccess();
     *
     * //text$ emits:        -initial--pending-success(string)-failure-success(string)
     * //successTest$ emits: ------------------string------------------string
     * //Notice that we lose info about initial, pending and failure state, there is always remote data with success state.
     * ```
     *
     */
    function filterSuccess() {
        return this.filter(RemoteDataUtils.isSuccess).map(function (data) { return data.value; });
    }
    RemoteDataUtils.filterSuccess = filterSuccess;
    rxjs_1.Observable.prototype['filterSuccess'] = filterSuccess;
    /**
     * When you want to combine two or more remote data observables, but you want to subscribe only to first remote data observable. Example:
     * ```ts
     * const firstName$: Observable<RemoteData<string>> = ...;
     * const lastName$: Observable<RemoteData<string>> = ...;
     * const patronymic$: Observable<RemoteData<string>> = ...;
     * const fullName$ = firstName$.withLatestFromRD(lastName$, patronymic$).mapRD(([firstName, lastName, patronymic]) => {
     * 		return `${firstName} ${lastName} ${patronymic}`;
     * });
     *
     * //firstName$ emits:  initial-pending--------------------------------------success('a')--pending-success('d')--
     * //lastName$ emits:   --------initial-pending-success('b')-----------------------------------------------------
     * //patronymic$ emits: ----------------initial-pending-success('c')-----------------------success('g')----------
     * //fullName$ emits:   -----------------------------------------------------success('abc')-------success('dbg')
     * ```
     */
    function withLatestFromRD() {
        var streams = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            streams[_i] = arguments[_i];
        }
        return this.withLatestFrom.apply(this, streams).map(function (values) { return RemoteDataUtils.combine.apply(void 0, values); });
    }
    RemoteDataUtils.withLatestFromRD = withLatestFromRD;
    rxjs_1.Observable.prototype['withLatestFromRD'] = withLatestFromRD;
    function toProperty() {
        return this.distinctUntilChanged().shareReplay(1);
    }
    RemoteDataUtils.toProperty = toProperty;
    rxjs_1.Observable.prototype['toProperty'] = toProperty;
    function toPropertyRD() {
        return this.distinctUntilChanged(function (a, b) { return a === b || RemoteDataUtils.strictRDSetoid.equals(a, b); }).shareReplay(1);
    }
    RemoteDataUtils.toPropertyRD = toPropertyRD;
    rxjs_1.Observable.prototype['toPropertyRD'] = toPropertyRD;
    function toPropertyRDOption() {
        return this.distinctUntilChanged(function (a, b) { return a === b || RemoteDataUtils.strictRDOptionSetoid.equals(a, b); }).shareReplay(1);
    }
    RemoteDataUtils.toPropertyRDOption = toPropertyRDOption;
    rxjs_1.Observable.prototype['toPropertyRDOption'] = toPropertyRDOption;
})(RemoteDataUtils = exports.RemoteDataUtils || (exports.RemoteDataUtils = {}));
exports.remoteData = {
    //HKT
    URI: exports.URI,
    //Monad
    of: RemoteDataUtils.success,
    ap: RemoteDataUtils.ap,
    map: RemoteDataUtils.map,
    chain: RemoteDataUtils.chain,
    //Foldable
    reduce: RemoteDataUtils.reduce,
    //Alt
    alt: RemoteDataUtils.alt,
    //Extend
    extend: RemoteDataUtils.extend,
};
(function (RemoteDataUtils) {
    function combine() {
        var list = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            list[_i] = arguments[_i];
        }
        if (list.length === 0) {
            return RemoteDataUtils.success(array_utils_1.ArrayUtils.empty);
        }
        return Traversable_1.sequence(exports.remoteData, Array_1.array)(list);
    }
    RemoteDataUtils.combine = combine;
    function combineLatestRD() {
        var list = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            list[_i] = arguments[_i];
        }
        var isEmpty = false;
        if (list.length === 0) {
            isEmpty = true;
        }
        var first = list[0];
        if (Array.isArray(first) && first.length === 0) {
            isEmpty = true;
        }
        if (isEmpty) {
            return rxjs_1.Observable.of(RemoteDataUtils.success(array_utils_1.ArrayUtils.empty));
        }
        return combineLatest_1.combineLatest.apply(void 0, list.concat([combine]));
    }
    RemoteDataUtils.combineLatestRD = combineLatestRD;
    function combineLatestRDNEA(list) {
        return combineLatestRD(list.toArray()).mapRD(function (_a) {
            var first = _a[0], last = _a.slice(1);
            return new NonEmptyArray_1.NonEmptyArray(first, last);
        });
    }
    RemoteDataUtils.combineLatestRDNEA = combineLatestRDNEA;
    function deserialize(data) {
        switch (data.status) {
            case RemoteDataStatus.Initial:
                return RemoteDataUtils.initial;
            case RemoteDataStatus.Pending:
                return RemoteDataUtils.pending;
            case RemoteDataStatus.Failure:
                return RemoteDataUtils.failure(data.error);
            case RemoteDataStatus.Success:
                return RemoteDataUtils.success(data.value);
        }
    }
    RemoteDataUtils.deserialize = deserialize;
})(RemoteDataUtils = exports.RemoteDataUtils || (exports.RemoteDataUtils = {}));
